import styled, { css } from "styled-components";
import { theme } from "../styles/theme";
import ProductTabs from "../components/category/ProductTabs";
import Header from "../components/header/Header";
import SectionHeader from "../components/SectionHeader";
import ProductNavDropdown from "../components/category/ProductNavDropdown";
import { BrowserRouter as Router, useParams } from "react-router-dom";
import { ProducService } from "../service/ProductService";
import React from "react";
import GlobalParallaxBanner from "../components/GlobalParallaxBanner";
import BannerParalaxImg from "../images/lifestyle/e1825aca70e044abdf18c46e9760e080.jpg";
import useToggleHeaderOnScroll from "../hooks/useToggleHeaderOnScroll";
import { slugify, deslugify } from "../utils/slug";

const ProductsContainer = styled.div``;

const Banner = styled.div`
  height: 560px !important;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export default function Category() {
  const { toggleHeader } = useToggleHeaderOnScroll();

  const service = new ProducService();
  const { category: categorySlug } = useParams();

  const [dataByCategory, setDataByCategory] = React.useState([]);

  const [categories, setCategories] = React.useState([]);
  const [resolvedCategoryName, setResolvedCategoryName] = React.useState("");

  React.useEffect(() => {
    const fetchCategories = async () => {
      const _categories = await service.getCategory();
      setCategories(_categories);
    };
    fetchCategories();
  }, []);

  React.useEffect(() => {
    if (!categories.length || !categorySlug) {
      if (categorySlug) {
        setResolvedCategoryName(deslugify(categorySlug));
      }
      return;
    }

    const currentCategory =
      categories.find(
        (item) => slugify(item.category) === slugify(categorySlug)
      ) || null;

    if (currentCategory) {
      setResolvedCategoryName(currentCategory.category);
    } else {
      setResolvedCategoryName(deslugify(categorySlug));
    }
  }, [categories, categorySlug]);

  React.useEffect(() => {
    const fetchCategoryData = async () => {
      if (!resolvedCategoryName) return;
      const list = await service.getDataByCategory(resolvedCategoryName);
      setDataByCategory(list);
    };
    fetchCategoryData();
  }, [resolvedCategoryName]);

  const displayCategoryName =
    resolvedCategoryName || deslugify(categorySlug || "");

  return (
    <>
      <Header sectionIn={toggleHeader} />
      <SectionHeader title={displayCategoryName} />
      {dataByCategory.length > 0 && (
        <>
          <ProductNavDropdown
            category={displayCategoryName}
            categories={categories}
          />
          <ProductsContainer>
            <ProductTabs data={dataByCategory} />
          </ProductsContainer>
        </>
      )}
      <GlobalParallaxBanner background={BannerParalaxImg} />
    </>
  );
}
